import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const AvaibookStore = GenericCollectionFactory("AVAIBOOK-INTEGRATION", "id");